import api from '../shared/services/api';

export interface ModerationStats {
  totalStories: number;
  pendingReview: number;
  aiReviewPending: number;
  adminReviewPending: number;
  approved: number;
  rejected: number;
  revisionRequested: number;
  appealPending: number;
  totalAppeals: number;
  pendingAppeals: number;
  approvedAppeals: number;
  rejectedAppeals: number;
  approvalRate: number;
  appealSuccessRate: number;
}

export interface AiStats {
  totalAnalyzed: number;
  aiSafe: number;
  aiUnsafe: number;
  avgConfidence: number;
  aiAccuracy: number;
}

export interface ViolationData {
  violationType: string;
  count: number;
}

export interface ActivityData {
  date: string;
  total: number;
  approved: number;
  rejected: number;
}

export interface ReviewerData {
  reviewerId: string;
  reviewCount: number;
  approvedCount: number;
  rejectedCount: number;
}

export interface ReviewTimeStats {
  avgReviewTimeHours: number;
  minReviewTimeHours: number;
  maxReviewTimeHours: number;
}

export interface DashboardData {
  overall: ModerationStats;
  ai: AiStats;
  violations: ViolationData[];
  activity: ActivityData[];
  topReviewers: ReviewerData[];
  reviewTime: ReviewTimeStats;
}

class ModerationService {
  async getDashboardData(): Promise<DashboardData> {
    const response = await api.get('/admin/moderation/dashboard');
    return response.data;
  }

  async getOverallStats(): Promise<ModerationStats> {
    const response = await api.get('/admin/moderation/stats/overall');
    return response.data;
  }

  async getAiStats(): Promise<AiStats> {
    const response = await api.get('/admin/moderation/stats/ai');
    return response.data;
  }

  async getViolationBreakdown(): Promise<ViolationData[]> {
    const response = await api.get('/admin/moderation/stats/violations');
    return response.data;
  }

  async getModerationActivity(days: number = 30): Promise<ActivityData[]> {
    const response = await api.get(`/admin/moderation/stats/activity?days=${days}`);
    return response.data;
  }

  async getTopReviewers(limit: number = 10): Promise<ReviewerData[]> {
    const response = await api.get(`/admin/moderation/stats/reviewers?limit=${limit}`);
    return response.data;
  }

  async getReviewTimeStats(): Promise<ReviewTimeStats> {
    const response = await api.get('/admin/moderation/stats/review-time');
    return response.data;
  }
}

export default new ModerationService();
